import React, { useState, useEffect } from 'react';
import { userService } from '../services/userService';
import { adminService } from '../services/adminService';
import { convertAllSpacesInObject } from '../utils/regex';
import styles from '../assets/css/admin-registration.module.css';
import '../assets/css/common.css';
import CustomButtons from '../components/CustomButtons';

function AdminMemberRegistration() {
  const [formData, setFormData] = useState({
    email: '',
    branch_id: '',
    role_id: '',
    name: '',
    furigana: ''
  });
  
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const data = await adminService.getBranches();
        setBranches(data.branches || []);
      } catch (e) {
        console.error('支社一覧取得エラー:', e);
      }
    };
    fetchBranches();

    setRoles([
      { id: 2, name: '管理者' },
      { id: 3, name: '人事' },
      { id: 4, name: '支社長' },
      { id: 5, name: '一般社員' }
    ]);
  }, []);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (loading) return; // 連打防止

    setErrors([]);
    setSuccessMessage('');
    
    const newErrors = [];
    
    if (!formData.email) newErrors.push('メールアドレスは必須です。');
    if (!formData.branch_id) newErrors.push('支社は必須です。');
    if (!formData.role_id) newErrors.push('権限は必須です。');
    if (!formData.name) newErrors.push('名前は必須です。');
    if (!formData.furigana) {
      newErrors.push("フリガナは必須です。");
    } else if (!/^[ァ-ヶー 　]+$/.test(formData.furigana)) {
      newErrors.push("フリガナは全角カタカナで入力してください。");
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      newErrors.push('有効なメールアドレスを入力してください。');
    }
    
    if (newErrors.length > 0) {
      setErrors(newErrors);
      return;
    }
    
    setLoading(true);
    try {
      const dataToSend = { ...formData };
      const sanitizedDataToSend = convertAllSpacesInObject(dataToSend);
      const response = await userService.register(sanitizedDataToSend);
      const msg = response?.message || '';
      if (msg.includes('メールの送信に失敗')) {
        setSuccessMessage('ユーザーは登録されましたが、メールの送信に失敗しました。手動でログイン情報をお伝えください。');
      } else {
        setSuccessMessage('ユーザーが正常に登録され、ログイン情報がメールで送信されました。');
      }
      
      setFormData({
        email: '',
        branch_id: '',
        role_id: '',
        name: '',
        furigana: ''
      });
    } catch (error) {
      setErrors([error.message || 'ユーザー登録に失敗しました。']);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className={styles.mainContents}>
      <div className={styles.container}>
        <div className={styles["registration-card"]}>
          <h1 className={`${styles["text-primary"]} text-center mb-4`}>新規メンバー登録</h1>
          
          {/* エラーメッセージ表示 */}
          {errors.length > 0 && (
            <div className={styles["error-message"]}>
              <ul className="mb-0">
                {errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}
          
          {/* 成功メッセージ表示 */}
          {successMessage && (
            <div className={styles["success-message"]}>
              {successMessage}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
              <div className={styles["form-group"]}>
                <label className={styles["form-label"]}>氏名</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={styles["form-control"]}
                  placeholder="例: 山田　太郎"
                />
              </div>
              
              <div className={styles["form-group"]}>
                <label className={styles["form-label"]}>フリガナ</label>
                <input
                  type="text"
                  name="furigana"
                  value={formData.furigana}
                  onChange={handleChange}
                  className={styles["form-control"]}
                  placeholder="例: ヤマダ　タロウ"
                />
              </div>
            
              <div className={styles["form-group"]}>
                <label className={styles["form-label"]}>メールアドレス</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={styles["form-control"]}
                  placeholder="例: yamada@example.com"
                />
              </div>
              
              <div className={styles["select-group"]}>
                <label className={styles["form-label"]}>支社</label>
                <select
                  name="branch_id"
                  value={formData.branch_id}
                  onChange={handleChange}
                  className={styles["form-control"]}
                >
                  <option value="">選択してください</option>
                  {branches.map(branch => (
                    <option key={branch.id} value={branch.id}>{branch.name}</option>
                  ))}
                </select>
              </div>
              
              <div className={styles["select-group"]}>
                <label className={styles["form-label"]}>権限</label>
                <select
                  name="role_id"
                  value={formData.role_id}
                  onChange={handleChange}
                  className={styles["form-control"]}
                >
                  <option value="">選択してください</option>
                  {roles.map(role => (
                    <option key={role.id} value={role.id}>{role.name}</option>
                  ))}
                </select>
              </div>
              
              <div className="alert alert-info" style={{fontSize:'0.9rem'}}>
                パスワードは自動生成され、登録メールに記載されます。
              </div>
              
              <div className={styles["btn-container"]}>
                <CustomButtons
                  leftLabel="戻る"
                  rightLabel="メンバーを登録"
                  rightLoadingLabel="登録中..."
                  rightLoading={loading}
                  rightDisabled={loading}
                  rightType="submit"
                  onLeftClick={() => window.history.back()}
                />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AdminMemberRegistration;
